// src/PlatForms/SelfLMS/Hooks/Courses/useEnrolledCourseDetails.js
import { useState, useEffect } from 'react';
import { selfLearnerService } from 'PlatForms/SelfLMS/Services/Courses/CourseService';

const useEnrolledCourseDetails = (enrollmentId) => {
  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEnrolledCourseDetails = async () => {
    try {
      console.log(' Starting to fetch enrolled course details...');
      setLoading(true);
      setError(null);
      
      const data = await selfLearnerService.getEnrolledCourseDetails(enrollmentId);
      console.log(' Enrolled course details received:', data);
      
      setEnrollment(data);
    } catch (err) {
      console.error(' Error fetching enrolled course details:', err);
      setError(err.response?.data?.message || err.message || 'Failed to fetch course details');
      setEnrollment(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (enrollmentId) {
      fetchEnrolledCourseDetails();
    }
  }, [enrollmentId]);

  const refetch = () => {
    fetchEnrolledCourseDetails();
  };

  return {
    enrollment,
    loading,
    error,
    refetch
  };
};

export default useEnrolledCourseDetails;